import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const Header = styled.div`
  width: 100%;
  background: ${colors.WHITE};
`;

export const HeaderContent = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
`;

export const HeaderIcon = styled.div`
  height: 9vh;
  width: 9vh;
`;

export const HeaderInfo = styled.div`
  margin-left: 3rem;
`;

export const EvaluationTitle = styled.div`
  font-size: 1.6rem;
  font-family: metropolis;
  font-weight: bold;
  gap: 1.5rem;
  margin-bottom: 0.5rem;
`;

export const EvaluationSubTitle = styled.div`
  font-size: 0.9rem;
  font-family: metropolis;
  gap: 4rem;
  font-weight: 600;
`;
export const EditEvaluationIcon = styled.div`
  background: ${colors.GREEN_LEAF};
  display: flex;
  align-items: center;
  border-radius: 50%;
  padding: 0.4rem;
  cursor: pointer;
  top: 0rem;
  right: 3rem;
  position: absolute;
  margin-top: 2rem;
  color: ${colors.WHITE};
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  position: absolute;
  bottom: 0.5rem;
  right: 1rem;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FiltersContainer = styled.div`
  width: 95%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

export const SearchContainer = styled.div`
  width: 40%;
`;

export const DropDownsContainer = styled.div`
  width: 60%;
  display: flex;
  justify-content: end;
`;

export const saveButton = {
  display: 'flex',
  height: '2.5rem',
  maxWidth: '25vw',
  borderRadius: '0.5rem',
  cursor: 'pointer',
  background: colors.WHITE,
  color: colors.BLACK,
  border: `0.1rem solid ${colors.GRAY}`,
  fontSize: '0.75rem',
  fontFamily: 'metropolis',
  fontWeight: 'bold',
};

export const publishButton = {
  display: 'flex',
  height: '2.5rem',
  maxWidth: '25vw',
  borderRadius: '0.5rem',
  cursor: 'pointer',
  background: colors.GREEN_LEAF,
  fontSize: '0.75rem',
  fontFamily: 'metropolis',
  fontWeight: 'bold',
};

export const disabledButton = {
  display: 'flex',
  height: '2.5rem',
  maxWidth: '25vw',
  borderRadius: '0.5rem',
  cursor: 'disabled',
  background: colors.WHITE,
  color: colors.BLACK,
  border: `0.1rem solid ${colors.GRAY}`,
  fontSize: '0.75rem',
  fontFamily: 'metropolis',
  fontWeight: 'bold',
  opacity: '0.5',
};

export const disabledPublishButton = {
  display: 'flex',
  height: '2.5rem',
  maxWidth: '25vw',
  borderRadius: '0.5rem',
  cursor: 'disabled',
  background: colors.GRAY,
  fontSize: '0.75rem',
  fontFamily: 'metropolis',
  fontWeight: 'bold',
};

export default {
  Header,
  HeaderContent,
  HeaderIcon,
  HeaderInfo,
  EvaluationTitle,
  EvaluationSubTitle,
  EditEvaluationIcon,
  SearchContainer,
  Content,
  FiltersContainer,
  DropDownsContainer,
  publishButton,
  ButtonContainer,
  saveButton,
  disabledButton,
  disabledPublishButton,
};
